import Typography from '@mui/material/Typography';
import React from 'react';

interface Props {
  readonly value: string;
}

export const FieldValue: React.FC<Props> = (props: Props): React.ReactElement => {
  return (
    <Typography variant="body2" color="text.primary">
      {props.value}
    </Typography>
  );
};
